module.exports = __webpack_public_path__ + "img/slide3-action-steps.7beb90b8.png";